import { AxiosResponse } from "axios";
import client from "../client";
import { getApplicationNameConfig } from "./GetApplicationNameConfig";
import { GetApplicationNameResponse } from "./types";

const getApplicationName = ({
  applicationId,
}: {
  applicationId: string;
}): Promise<AxiosResponse<GetApplicationNameResponse>> =>
  client({ ...getApplicationNameConfig(applicationId) });

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getApplicationName,
};
